import axios, { isAxiosError } from "axios";
import { MOSIDA_API_BASE_URL } from "../config/apiUrls";
import {
  DEFAULT_PROCESSING_FEE_PERCENT,
  DEFAULT_SALES_TAX_PERCENT,
  getMuseumFeeTaxPercents,
  MuseumFeeTaxSource,
} from "../utils/museumFeeTax";

const currentMuseumUrl = `${MOSIDA_API_BASE_URL}/museums/current`;

export type MuseumFeeTaxSettings = {
  processingFeePercent: number;
  salesTaxPercent: number;
};

function extractMuseumRecord(payload: unknown): MuseumFeeTaxSource {
  if (!payload || typeof payload !== "object") return null;

  const root = payload as Record<string, unknown>;
  if (
    root.processingFeePercent != null ||
    root.salesTaxPercent != null ||
    root.processing_fee_percent != null ||
    root.sales_tax_percent != null
  ) {
    return root as MuseumFeeTaxSource;
  }

  const data = root.data;
  if (data && typeof data === "object") {
    return data as MuseumFeeTaxSource;
  }

  return root as MuseumFeeTaxSource;
}

export function parseMuseumFeeTaxSettings(payload: unknown): MuseumFeeTaxSettings {
  return getMuseumFeeTaxPercents(extractMuseumRecord(payload));
}

export async function fetchMuseumFeeTaxSettings(): Promise<MuseumFeeTaxSettings> {
  try {
    const response = await axios.get(currentMuseumUrl, {
      headers: { accept: "*/*" },
    });
    return parseMuseumFeeTaxSettings(response.data);
  } catch (error) {
    if (isAxiosError(error)) {
      console.warn("[museumService] Failed to load museum fee/tax:", error.message);
    }
    return {
      processingFeePercent: DEFAULT_PROCESSING_FEE_PERCENT,
      salesTaxPercent: DEFAULT_SALES_TAX_PERCENT,
    };
  }
}
